module.exports = __webpack_public_path__ + "img/imageLib-button.a78f70d2.png";